<template lang="pug">
  modal.discard-modal(:title='$t("profile.modal.title")' @closeModal='closeModal')
    .column
      p.text-normal.text-container
        | {{ $t("profile.modal.text") }}
      .row.space-between
        button.secondary-button.continue(@click='confirm' type='button')
          | {{ $t("profile.modal.continueWithoutSaving") }}
        button.primary-button(@click='closeModal' type='button')
          | {{ $t("profile.modal.cancel") }}
</template>

<script>
import { mapActions, mapState } from 'vuex'
import get from 'lodash/get'

import Modal from '../Modal'

export default {
  components: { Modal },
  computed: {
    ...mapState({
      confirmFunc: state => get(state.behavior, 'discardChangesModal.props.confirmFunc'),
      funcProps: state => get(state.behavior, 'discardChangesModal.props.funcProps')
    })
  },
  methods: {
    ...mapActions([ 'hideElement' ]),
    closeModal() {
      this.hideElement({ element: 'discardChangesModal' })
    },
    async confirm() {
      await this.confirmFunc(this.funcProps)
      this.closeModal()
    }
  }
}
</script>

<style lang="scss" scoped>
.discard-modal {
  .modal-container {
    max-width: 464px;
  }
}

.text-container {
  margin: 25px 0 48px;
}

.continue {
  --max-width: 220px;
}
</style>
